<template>
  <div id="peacock">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
@import '~@/assets/style/index.scss';
</style>
